/**
 * Makes all links in article body content open in a new window.
 * Adds target="_blank" and rel="noopener noreferrer" to external/internal links.
 */
export function initArticleLinks(doc: Document = document): void {
  const articleBody = doc.querySelector('.fc-article__body');
  if (!articleBody) return;

  // Select all links within the article body, excluding navigation/metadata links
  const links = articleBody.querySelectorAll<HTMLAnchorElement>('a[href]');

  links.forEach((link) => {
    // Set target to open in new window
    link.target = '_blank';
    // Add rel for security when opening external links
    link.rel = 'noopener noreferrer';
  });
}
